import React, { useEffect, useState } from 'react';
import styles from './ProductAttributesModal.module.css';
import { apiService } from '../../services/api';

const ProductAttributesModal = ({ attributes, setAttributes, onClose }) => {
  const [availableAttrs, setAvailableAttrs] = useState([]);
  const [newAttrName, setNewAttrName] = useState('');
  const [newAttrValue, setNewAttrValue] = useState('');

  useEffect(() => {
    // Obtener atributos disponibles desde apiService
    apiService.getProductAttributes()
      .then(data => setAvailableAttrs(data.attributes || []));
  }, []);

  const handleAddAttribute = async () => {
    if (!newAttrName || !newAttrValue) return;
    const existing = availableAttrs.find(a => a.name === newAttrName);
    if (existing) {
      setAttributes([...attributes, { attribute_id: existing.id, attribute_name: newAttrName, value: newAttrValue }]);
    } else {
      // Crear nuevo atributo en la base de datos usando apiService
      try {
        const data = await apiService.createProductAttribute(newAttrName);
        if (data.attribute) {
          setAvailableAttrs([...availableAttrs, data.attribute]);
          setAttributes([...attributes, { attribute_id: data.attribute.id, attribute_name: newAttrName, value: newAttrValue }]);
        }
      } catch (err) {
        // Manejo de error opcional
      }
    }
    setNewAttrName('');
    setNewAttrValue('');
  };

  const handleValueChange = (idx, value) => {
    const updated = [...attributes];
    updated[idx].value = value;
    setAttributes(updated);
  };

  const handleRemove = (idx) => {
    const updated = [...attributes];
    updated.splice(idx, 1);
    setAttributes(updated);
  };

  // Solo cierra el modal, no guarda en la base de datos
  const handleSave = () => {
    onClose();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h2>Atributos personalizados</h2>
        <div className={styles.attrList}>
          {attributes.map((attr, idx) => (
            <div key={attr.attribute_id} className={styles.attrRow}>
              <span className={styles.attrName}>{attr.attribute_name}</span>
              <input
                value={attr.value}
                onChange={e => handleValueChange(idx, e.target.value)}
                className={styles.attrValue}
              />
              <button className={styles.removeBtn} onClick={() => handleRemove(idx)}>✖</button>
            </div>
          ))}
        </div>
        <div className={styles.addAttrRow}>
          <input
            placeholder="Nombre del atributo"
            value={newAttrName}
            onChange={e => setNewAttrName(e.target.value)}
            className={styles.attrName}
          />
          <input
            placeholder="Valor"
            value={newAttrValue}
            onChange={e => setNewAttrValue(e.target.value)}
            className={styles.attrValue}
          />
          <button className={styles.addBtn} onClick={handleAddAttribute}>Agregar</button>
        </div>
        <div className={styles.modalActions}>
          <button className={styles.saveBtn} type="button" onClick={handleSave}>Guardar</button>
          <button className={styles.cancelBtn} type="button" onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
};

export default ProductAttributesModal;